import qs from 'query-string';

export function buildAppPath(path: string, params?: { [key: string]: string | number | boolean | null | undefined }) {
  const windowBase = window.location.pathname.split('/').slice(1).shift();
  const pathBase = path.split('/').slice(1).shift();
  const query = params ? `?${qs.stringify(params)}` : '';

  if (typeof windowBase === 'string' && windowBase !== 'app' && windowBase !== pathBase) {
    return `/${windowBase}${path}${query}`;
  }
  return `${path}${query}`;
}

export function navigate(path: string, params?: { [key: string]: string | number | boolean | null | undefined }) {
  window.location.assign(buildAppPath(path, params));
}

export function navigateOut(path: string, params?: { [key: string]: string | number | boolean | null | undefined }) {
  window.open(buildAppPath(path, params), '_blank');
}

export function locationReplace(path: string) {
  window.location.replace(path);
}

export function addUrlParams(url: string, extraParams: { [key: string]: string | undefined }): string {
  const { url: baseUrl, query } = qs.parseUrl(url);

  return qs.stringifyUrl({ url: baseUrl, query: { ...query, ...extraParams } });
}
